
export const IEG_GLOBAL_GAMES = 'IEG Global Games';
export const UPCOMING_GAMES = 'Upcoming Games';
export const NEWRELEASEGAMES = 'New Release Games';
export const NOTEWORTHYGAMES = 'Noteworthy Games';
export const BIGRISER = 'Big Riser';